import { render, staticRenderFns } from "./decoration-quote-info.vue?vue&type=template&id=69bdf973&scoped=true&"
import script from "./decoration-quote-info.vue?vue&type=script&lang=js&"
export * from "./decoration-quote-info.vue?vue&type=script&lang=js&"
import style0 from "./decoration-quote-info.vue?vue&type=style&index=0&id=69bdf973&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69bdf973",
  null
  
)

export default component.exports